export default "__VITE_ASSET__D3CxTvL0__"